// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__uNuAT","rootNoMargin":"styles_rootNoMargin__yrAD6"};